/**
 * @module components\ghTablePage\custormQuery
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class CustormQuery extends Vue {
  private menu = false;

  @Prop()
  private headers!: IProp[];

  private get conditions() {
    let cons: IQueryCondtion[] = [];
    if (this.headers) {
      for (const h of this.headers) {
        if (h.isQuery) {
          let con: IQueryCondtion = {
            column: h.value,
            prop: h,
            symbol: "=",
            value: ""
          };
          cons.push(con);
        }
      }
    }
    return cons;
  }

  private get liseners() {
    return Object.assign({}, this.$listeners);
  }

  private submit(condtions) {
    this.$emit("submit", condtions);
  }
}
